module.exports = __webpack_public_path__ + "static/media/02GalleryPuppets.67124d6d.jpeg";